import {
    Attachment,
    ComposeMessageEditorErrorType,
    ComposeStateType,
} from "../../reducer.types";
import { validateAttachmentLoading } from "./validateAttachmentLoading";
import { validateClinicianMessageLength } from "./validateClinicianMessageLength";
import { validatePlaceholderInMessage } from "./validatePlaceholderInMessage";

export type ValidateClinicianMessageProps = {
    messageBody: string;
    messageSignature: string;
    attachments: Attachment[];
    originalGreeting: string;
    originalSignature: string;
    template: ComposeStateType["template"];
};

export const validateClinicianMessage = (
    arg: ValidateClinicianMessageProps,
): ComposeMessageEditorErrorType => {
    return {
        ...validateAttachmentLoading(arg),
        ...validatePlaceholderInMessage(arg),
        ...validateClinicianMessageLength(arg),
    };
};
